import AddIcon from '@mui/icons-material/Add';
import { GridColDef } from '@mui/x-data-grid-premium';
import EnhancedDataGrid from 'components/enhanced/data-grid/EnhancedDataGrid';
import { useIsDirector } from 'shared/permissions/useIsDirector';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import { IEquipment } from 'features/inventory/equipments/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TickectColumns } from './TicketsColums';
import { ToolbarFilter, ToolbarAction } from 'components/enhanced/types/toolbar.types';
import { ticketingService } from 'features/inventory/ticketing/TicketingService';

interface TicketProp {
  equipment?: { id: number | string; code?: string } | IEquipment | null;
}

export const TicketsTab = ({ equipment }: TicketProp) => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.tickets';
  const navigate = useNavigate();

  const isDisableEdit = useIsDirector() || useIsSupplier();

  const [dateRange, setDateRange] = useState<[string | null, string | null]>([null, null]);

  const columns: GridColDef[] = TickectColumns();

  const toolbarFilters: ToolbarFilter[] = [
    {
      id: 'created_at_range',
      type: 'dateRange',
      value: dateRange,
      onChange: (val) => setDateRange(val),
      gridField: 'created_at',
      gridOperators: ['onOrAfter', 'onOrBefore']
    }
  ];

  const toolbarActions: ToolbarAction[] = [
    {
      id: 'add',
      label: t(`${translationPrefix}.add`),
      variant: 'contained',
      startIcon: <AddIcon />,

      onClick: () => {
        navigate(`/tenant/equipments/ticketing/new/?equipmentId=${equipment?.id}`);
      },
      visible: !isDisableEdit
    }
  ];

  return (
    <>
      <EnhancedDataGrid
        columns={columns}
        service={ticketingService}
        outerParams={{
          equipment: equipment?.code
        }}
        useGenericToolbar={true}
        genericToolbarConfig={{
          filters: toolbarFilters,
          actions: toolbarActions
        }}
        showGridControls={false}
        disableDelete
      />
    </>
  );
};
